import { render, staticRenderFns } from "./UserTrainingHistory.vue?vue&type=template&id=e5961278&"
import script from "./UserTrainingHistory.vue?vue&type=script&lang=js&"
export * from "./UserTrainingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports